import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=f2586ddc&"
import script from "./notifications.vue?vue&type=script&lang=js&"
export * from "./notifications.vue?vue&type=script&lang=js&"
import style0 from "./notifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2586ddc')) {
      api.createRecord('f2586ddc', component.options)
    } else {
      api.reload('f2586ddc', component.options)
    }
    module.hot.accept("./notifications.vue?vue&type=template&id=f2586ddc&", function () {
      api.rerender('f2586ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/notifications/notifications.vue"
export default component.exports